import { render } from "./Entidades.vue?vue&type=template&id=01e35a06&scoped=true"
import script from "./Entidades.vue?vue&type=script&lang=js"
export * from "./Entidades.vue?vue&type=script&lang=js"

import "./Entidades.vue?vue&type=style&index=0&id=01e35a06&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e35a06"]])

export default __exports__